export default class sidebarHistory {
    constructor() {
        return {
            template: require('../../../../views/maileditor/history.html'),
            replace: true,
            restrict: 'E',
            controller: HistoryCtrl,
            controllerAs: 'history',
            scope: {
                type: '='
            }
        };
    }
}

class HistoryCtrl {
    constructor($scope, $stateParams, Automation, Campaign, SubscriberForm) {
        this._stateParams = $stateParams;
        this._scope = $scope;
        
        this.automationRepo = Automation;
        this.campaignRepo = Campaign;
        this.subscriberFormRepo = SubscriberForm;

        if (this._stateParams.id) {
            this.getHistory(this._stateParams.id);
        } else if (this._stateParams.dispatcherId) {
            this.getHistory(this._stateParams.dispatcherId);
        }

        this._scope.$on('dispatcher:updated', () => {
            let dispatcherId = this._stateParams.id ? this._stateParams.id : this._stateParams.dispatcherId;
            this.getHistory(dispatcherId);
        });
    }

    generateHistoryData(results) {
        this.displayList = [];
        let resultsArr = [];

        angular.forEach(results.data, (result) => {
            if (resultsArr[result.created_at] === undefined) {
                resultsArr[result.created_at] = [];
            }

            resultsArr[result.created_at][result.content_type_id] = result.id;
            resultsArr[result.created_at]['name'] = result.created_at;
        });

        this.historyMeta = resultsArr;

        angular.forEach(Object.keys(resultsArr), (key) => {
            this.displayList.push(resultsArr[key])
        });

        if (this.displayList.length) {
            this.historySelect = this.displayList[0]['name'];
        }
    };

    getHistory(dispatcherId) {
        if (this._scope.type == 'automation') {
            if (this._stateParams.emailId) {
                this.automationRepo.getHistoryMeta(dispatcherId, this._stateParams.emailId).then((results) => {
                    this.generateHistoryData(results);
                })
            }
        } else if (this._scope.type == 'subscriberForm') {
            if (this._stateParams.emailId) {
                this.subscriberFormRepo.getHistoryMeta(dispatcherId).then((results) => {
                    this.generateHistoryData(results);
                });
            }
        } else {
            this.campaignRepo.getHistoryMeta(dispatcherId).then((results) => {
                this.generateHistoryData(results);
            })
        }
    };

    getHistoryHtml() {
        let htmlContentID, plainContentID;

        angular.forEach(Object.keys(this.historyMeta), (key) => {
            if (key === this.historySelect) {
                htmlContentID = this.historyMeta[key]['2'];
                plainContentID = this.historyMeta[key]['1'];
            }
        });
    
        if (htmlContentID) {
            this._scope.$emit('mailEditor:historicalHtml', 'content/' + htmlContentID + '/historyHtmlContent');
        }
    
        if (plainContentID) {
            this._scope.$emit('mailEditor:historicalPlain', 'content/' + plainContentID + '/historyPlainContent');
        }
    };
}
